import React from 'react';
import { SkeletonLine, SkeletonCircle, Box } from '@wix/design-system';
export function RegularAppBoxSkeleton({ className, }) {
    return (React.createElement(Box, { className: className, gap: "12px" },
        React.createElement(SkeletonCircle, { diameter: "42px" }),
        React.createElement(Box, { direction: "vertical" },
            React.createElement(SkeletonLine, { width: "168px", marginTop: "18px" }),
            React.createElement(SkeletonLine, { width: "342px", marginTop: "15px" }),
            React.createElement(SkeletonLine, { width: "117px", marginTop: "6px" }),
            React.createElement(SkeletonLine, { width: "30px", marginTop: "12px" }))));
}
//# sourceMappingURL=regular-app-box-skeleton.js.map